import { useState } from 'react';
import { TextInput, PasswordInput, Paper, Title, Text, Container, Button, Anchor } from '@mantine/core';
import { Link } from 'react-router-dom';
import { useDisclosure } from '@mantine/hooks';
import AuthModal from '@components/auth-modal';
import AuthLogo from '@components/auth-logo';
import { signUp } from '@services/authentication';
import classes from './auth-common.module.css';

interface SignUpProps {
  title?: string;
}

function SignUp({ title = 'Sign Up' }: SignUpProps) {
  const [username, setUsername] = useState('');
  const [givenName, setGivenName] = useState('');
  const [familyName, setFamilyName] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [opened, { open, close }] = useDisclosure(false);

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setError('');

    try {
      await signUp(username, password, givenName, familyName);
      open();
    } catch (err) {
      setError((err as Error)?.message || 'An error occurred');
    }
  };

  return (
    <Container size={420} my={40}>
      <AuthLogo />

      <Paper withBorder shadow="md" p={30} mt={30} radius="md">
        <Title ta="center" className={classes.title} pb={20}>
          {title}
        </Title>
        <TextInput label="First Name" placeholder="Alex" required onChange={(e) => setGivenName(e.target.value)} />
        <TextInput
          label="Last Name"
          placeholder="Traveler"
          required
          mt="md"
          onChange={(e) => setFamilyName(e.target.value)}
        />
        <TextInput
          label="Email"
          placeholder="alex.traveler@example.com"
          required
          mt="md"
          onChange={(e) => setUsername(e.target.value)}
        />
        <PasswordInput
          label="Create Password"
          placeholder="PackYourBags!2026"
          required
          mt="md"
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button fullWidth mt="xl" onClick={(event) => handleClick(event)}>
          Create Account
        </Button>
        {error && (
          <Text c="red" pt={20}>
            {error}
          </Text>
        )}
      </Paper>
      <AuthModal
        opened={opened}
        close={close}
        navTo="/confirmation"
        state={{ username }}
        title="Success"
        message="Please check your email for the confirmation code"
      />
      <Text c="dimmed" size="xs" ta="center" mt={16}>
        <Anchor size="xs" component={Link} to="/privacy">
          Privacy Policy
        </Anchor>
        &nbsp;·&nbsp;
        <Anchor size="xs" component={Link} to="/terms">
          Terms of Use
        </Anchor>
      </Text>
    </Container>
  );
}

export default SignUp;
